"use strict";
var ourWall = document.querySelector(".wall");
var ourSpider = document.querySelector(".spider");
var widthWall = ourWall.clientWidth;
var heightWall = ourWall.clientHeight;
var widthSpider = ourSpider.clientWidth;
var heightSpider = ourSpider.clientHeight;
var topPosition = heightWall / 2 - heightSpider / 2;
var leftPosition = widthWall / 2 - widthSpider / 2;
ourSpider.style.position = "absolute";
ourSpider.style.left = leftPosition + "px";
ourSpider.style.top = topPosition + "px";

//# sourceMappingURL=index.b9ace54d.js.map
